import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useScreenInfo = () => {
  const { data: screensMap = new Map(), isLoading } = useQuery({
    queryKey: ['screens-map'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('screens')
        .select('id, name, location, dimensions, *, ad_id');

      if (error) throw error;

      // Crear un mapa para acceso rápido
      const map = new Map();
      data?.forEach(screen => {
        map.set(screen.id, {
          id: screen.id,
          nombre: screen.name,
          ubicacion: screen.location,
          dimensiones: screen.dimensions
        });
      });

      return map;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
  });

  const getScreenInfo = (screenId: string) => {
    return screensMap.get(screenId) || {
      id: screenId,
      nombre: 'Pantalla no encontrada',
      ubicacion: 'N/A',
      dimensiones: 'N/A'
    };
  };

  return { getScreenInfo, isLoading };
}; 